import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Redirects /user/profile/edit to the current user's profile edit URL.
 */
const RedirectProfileEdit = () => {
  const { user, isAuthenticated } = useAuth();
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }
  const u = user as any;
  const to = u.uuid && u.slug
    ? `/user/${u.uuid}-${u.slug}/edit`
    : `/user/${u.username || user.id}/edit`;
  return <Navigate to={to} replace />;
};

export default RedirectProfileEdit;
